import { api } from '@/lib/axios';

export type CorbeilleEtat = 'archive' | 'supprime';
export interface CorbeilleItem { id: string; libelle: string }
export interface CorbeilleGroupe { entite: string; label: string; items: CorbeilleItem[] }

export async function listCorbeille(etat: CorbeilleEtat): Promise<CorbeilleGroupe[]> {
  const { data } = await api.get<CorbeilleGroupe[]>('/corbeille', { params: { etat } });
  return data;
}
export async function restaurerItem(entite: string, id: string, etat: CorbeilleEtat): Promise<void> {
  await api.post(`/corbeille/${entite}/${id}/restaurer`, null, { params: { etat } });
}
export async function purgerItem(entite: string, id: string): Promise<void> {
  await api.delete(`/corbeille/${entite}/${id}`);
}
